export const catalogCopy = {
  price: 'Price',
  allPrices: 'All prices',
  free: 'Free',
  paid: 'Paid',
  compatibility: 'Compatibility',
  allEngines: 'All engines',
  reset: 'Reset all filters',
  loading: 'Loading published assets…',
  unavailable: 'Published assets could not be loaded. Catalog results may be incomplete. Please try again.',
  retry: 'Try again',
  adapterNames: { generic: 'Generic', godot: 'Godot', unity: 'Unity', gamemaker: 'GameMaker', phaser: 'Phaser' } as Record<string, string>,
};
